import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-header-title',
  templateUrl: './st-header-title.component.html',
  styleUrls: ['./st-header-title.component.scss'],
  standalone: false
})
export class StHeaderTitleComponent {

  @Input()
  idVal: string = 'header-title-id';

  @Input()
  inputVal: string = '';

  @Input()
  color: string = '#000000'
}
